/**
 * @desc 批量下载
 */
import { OssDownloadBatchParam } from '@eastcoal/api/nexus/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type DownloadFileBatchParameter = OssDownloadBatchParam

const method = 'GET'
const url = '/nexus/oss/download/batch'

export const downloadFileBatchApi = (
  params?: DownloadFileBatchParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<string>({
    method,
    url,
    params,
    ...config
  })
}

downloadFileBatchApi.method = method
downloadFileBatchApi.url = url
